import { Right } from "@insightfulscience/shared-utils/either";
import routes, { gotoPath } from "../routes";

const forgotPassword = ({ email }) => ({ authService }) =>
	authService
		.forgotPassword(email)
		.then(gotoPath(routes.forgotPasswordSuccess))
		.then(Right);

export default forgotPassword;
